import { ReviewRequestView, ReviewView } from '@zola/svc-marketplace-ts-types';

import { Action } from 'redux';

import {
  receivedReview,
  reviewNonceMismatch,
  reviewNotFound,
  updatedReview,
} from '~/actions/types/reviewActionTypes';

export type ReviewState = {
  byUuid: Record<string, ReviewView | ReviewRequestView>;
  notFoundByUuid: Record<string, boolean>;
  mismatchByUuid: Record<string, string>;
};

// https://redux.js.org/recipes/structuring-reducers/normalizing-state-shape
const initialState: ReviewState = {
  // Look up a review by uuid
  byUuid: {},

  // When we look up a review by UUID and don't find it, enter it here
  notFoundByUuid: {},

  // When we look up a review by UUID+nonce and the nonce is invalid, enter it here
  mismatchByUuid: {},
};

const reviewReducer = (state = initialState, action?: Action): ReviewState => {
  if (!action) {
    return state;
  }
  if (reviewNotFound.match(action)) {
    const uuid = action.payload;
    return {
      ...state,
      notFoundByUuid: { ...state.notFoundByUuid, [uuid]: true },
    };
  }
  if (reviewNonceMismatch.match(action)) {
    const { uuid, nonce } = action.payload;
    return {
      ...state,
      // Not telling them what the real nonce is, just recording the one they used for lookup
      mismatchByUuid: { ...state.mismatchByUuid, [uuid]: nonce as string },
    };
  }
  if (receivedReview.match(action)) {
    const { uuid } = action.payload;

    return { ...state, byUuid: { ...state.byUuid, [uuid]: action.payload } };
  }

  if (updatedReview.match(action)) {
    const { reviewRequestUuid } = action.payload;
    if (reviewRequestUuid) {
      return { ...state, byUuid: { ...state.byUuid, [reviewRequestUuid]: action.payload } };
    }
  }

  return state;
};

export default reviewReducer;
